export default __webpack_public_path__ + "static/python-learn-coding-4e8a0cbc45ee427ca5779e9125035137.webp";